export default "__VITE_ASSET__Bwfsf7fD__"